import { AudienceExpressionType, AudienceMatchType } from "@front/m19-api-client";
import { SdTargetingType, SegmentEx } from "@front/m19-models";

export interface SdTargetingFormModel {
  targetingType: SdTargetingType | null;
  segment: SegmentEx | null;
  audienceExpressionType: AudienceExpressionType | null;
  audienceMatchType: AudienceMatchType | null;
  audienceLookback: number | null;
  isValid: boolean;
}

export type SdTargetingFormModelWithoutIsValid = Omit<SdTargetingFormModel, "isValid">;

export const TargetingTypeLabel = {
  [SdTargetingType.PRODUCT_AI_TARGETING]: "sd-targeting.ai-powered_targeting",
  [SdTargetingType.PRODUCT]: "sd-targeting.product_page",
  [SdTargetingType.REMARKETING]: "sd-targeting.remarketing",
};

export const EventTypeLabel: Record<AudienceExpressionType, string> = {
  [AudienceExpressionType.views]: "Views",
  [AudienceExpressionType.purchases]: "Purchases",
  [AudienceExpressionType.audience]: "Audience",
};

export const MatchTypeLabel: Record<AudienceMatchType, string> = {
  [AudienceMatchType.exactProduct]: "Exact Product",
  [AudienceMatchType.similarProduct]: "Similar Product",
  [AudienceMatchType.relatedProduct]: "Related Product",
  [AudienceMatchType.asinCategorySameAs]: "ASIN Category",
  [AudienceMatchType.audienceSameAs]: "Audience",
};

export type AudienceMatchTypeOption = {
  AudienceMatchType: AudienceMatchType;
  label: string;
  tooltip?: string;
  disabled?: boolean;
};
